import { Divider, Typography ,Card} from "antd";
import BinOutward from "../../../components/Wash/BinOutward/BinOutward";
import "../../../styles/global-ui.css";

const BinOutwardPage = ({ userData }) => {
  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
            Bin Outward
          </Typography.Title>
          <Typography.Text className="page-subtitle">
            Move bins outward and track their dispatch status
          </Typography.Text>
        </div>
      </div>

      <Divider className="page-divider" />
   <Card className="modern-card">
      <BinOutward userData={userData} />
      </Card>
    </div>
  );
};

export default BinOutwardPage;